import React from 'react';

import { useField } from 'formik';

import './index.scss';

const MutateTasksListColor = ({ name, ...props }) => {
  const [field] = useField(name);

  return (
    <div className="mutate-tasks-list-color">
      <h5>Color</h5>
      <input {...props} {...field} type="color" />
    </div>
  );
};

export default MutateTasksListColor;
